<template>
  <b-container fluid>
    <b-row class="justify-content-md-center row" v-b-toggle.accordion>
      <b-col cols='10'>
        <h3>{{ $t('logs.filter') }}:</h3>
      </b-col>
      <b-col cols='2'>
        <a class="fas fa-filter fa-2x float-right"></a>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-collapse id="accordion">
          <b-row v-on:change="getLogs()">
            <hr>
            <b-col cols="12">
              <b-row>
                <b-col cols="12">
                  {{ $t('logs.gates') }}:
                </b-col>
                <hr>
                <b-col cols="12">
                  <b-form-group>
                    <b-form-checkbox
                        v-for="option in options1"
                        v-model="selected"
                        :size="isMobile()? 'sm' : 'lg' "
                        :key="option.value"
                        :value="option.value"
                        name="flavour-4a"
                        inline
                    >
                      {{ $t('logs.gate') }} {{ option.value }}
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <b-form-checkbox
                        v-for="option in options2"
                        v-model="selected"
                        :size="isMobile()? 'sm' : 'lg' "
                        :key="option.value"
                        :value="option.value"
                        name="flavour-4a"
                        inline
                    >
                      {{ $t('logs.gate') }} {{ option.value }}
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <b-form-checkbox
                        v-for="option in options3"
                        v-model="selected"
                        :size="isMobile()? 'sm' : 'lg' "
                        :key="option.value"
                        :value="option.value"
                        name="flavour-4a"
                        inline
                    >
                      {{ $t('logs.gate') }} {{ option.value }}
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <b-form-checkbox
                        v-for="option in options4"
                        v-model="selected"
                        :size="isMobile()? 'sm' : 'lg' "
                        :key="option.value"
                        :value="option.value"
                        name="flavour-4a"
                        inline
                    >
                      {{ $t('logs.gate') }} {{ option.value }}
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <b-form-checkbox
                        v-for="option in options5"
                        v-model="selected"
                        :size="isMobile()? 'sm' : 'lg' "
                        :key="option.value"
                        :value="option.value"
                        name="flavour-4a"
                        inline
                    >
                      {{ $t('logs.gate') }} {{ option.value }}
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col cols="12">
                  {{ $t('logs.type.title') }}:
                </b-col>
                <b-col cols="12">
                  <b-form-group>
                    <b-form-checkbox
                        v-for="option in statusOptions"
                        v-model="selectedStatus"
                        :size="isMobile()? 'sm' : 'lg' "
                        :key="option.value"
                        :value="option.value"
                        name="flavour-4a"
                        inline
                    >
                      {{ $t(option.text) }}
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>

              </b-row>
            </b-col>
          </b-row>
        </b-collapse>
      </b-col>
    </b-row>
    <hr>
    <b-row v-if="log">
      <b-col cols="12">
        <b-row v-for="(log, index ) in logs" :key="log.id">
          <b-col :id="(log.id>prevId ?'bx':'')" cols="12" sm="12" v-if="log.event_type=='error'" class="event">
            <b-alert :class="isMobile() ? 'elements element': 'element'" variant="danger"
                     v-b-toggle="'accordion-'+log.id" show>
              <b v-if="log.code"> Kod karte: {{ log.code.substring(0, log.code.length - 6) }}
                {{ log.code.substring(log.code.length - 6, log.code.length - 1) }}
                {{ log.code.substring(log.code.length - 1, log.code.length) }} - </b>{{ log.event_msg }} na prolazu
              {{ log.gate_id }}<i class="fa fa-chevron-down float-right"></i>
              <b-collapse :id="'accordion-' + log.id" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>{{ log.msg_details }}</b-card-text>

                </b-card-body>
              </b-collapse>
              <footer class="blockquote-footer">
                <a class="float-right">{{ log.created_at | moment("DD.MM.YY., HH:mm") }}</a>
              </footer>
            </b-alert>
          </b-col>
          <b-col :id="(log.id>prevId ?'bx':'')" cols="12" v-if="log.event_type=='info'" class="event">
            <b-alert :class="isMobile() ? 'elements element': 'element'" variant='info' v-b-toggle="'accordion-'+log.id"
                     show>
              <b v-if="log.code"> Kod karte: {{ log.code.substring(0, log.code.length - 6) }}
                {{ log.code.substring(log.code.length - 6, log.code.length - 1) }}
                {{ log.code.substring(log.code.length - 1, log.code.length) }} - </b>{{ log.event_msg }} na prolazu
              {{ log.gate_id }}<i class="fa fa-chevron-down float-right"></i>
              <b-collapse :id="'accordion-' + log.id" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>{{ log.msg_details }}</b-card-text>

                </b-card-body>
              </b-collapse>
              <footer class="blockquote-footer">
                <a class="float-right">{{ log.created_at | moment("DD.MM.YY., HH:mm") }}</a>
              </footer>
            </b-alert>
          </b-col>
          <b-col :id="(log.id>prevId ?'bx':'')" cols="12" v-if="log.event_type=='warning'" class="event">
            <b-alert :class="isMobile() ? 'elements element': 'element'" variant="warning"
                     v-b-toggle="'accordion-'+log.id" show>
              <b v-if="log.code"> Kod karte: {{ log.code.substring(0, log.code.length - 6) }}
                {{ log.code.substring(log.code.length - 6, log.code.length - 1) }}
                {{ log.code.substring(log.code.length - 1, log.code.length) }} - </b>{{ log.event_msg }} na prolazu
              {{ log.gate_id }}<i class="fa fa-chevron-down float-right"></i>
              <b-collapse :id="'accordion-' + log.id" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>{{ log.msg_details }}</b-card-text>

                </b-card-body>
              </b-collapse>
              <footer class="blockquote-footer">
                <a class="float-right">{{ log.created_at | moment("DD.MM.YY., HH:mm") }}</a>
              </footer>
            </b-alert>
          </b-col>
          <b-col :id="(log.id>prevId ?'bx':'')" cols="12" v-if="log.event_type=='success'" class="event">
            <b-alert :class="isMobile() ? 'elements element': 'element'" variant="success"
                     v-b-toggle="'accordion-'+log.id" show>
              <b v-if="log.code"> Kod karte: {{ log.code.substring(0, log.code.length - 6) }}
                {{ log.code.substring(log.code.length - 6, log.code.length - 1) }}
                {{ log.code.substring(log.code.length - 1, log.code.length) }} - </b>{{ log.event_msg }} na prolazu
              {{ log.gate_id }}<i class="fa fa-chevron-down float-right"></i>
              <b-collapse :id="'accordion-' + log.id" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>{{ log.msg_details }}</b-card-text>

                </b-card-body>
              </b-collapse>
              <footer class="blockquote-footer">
                <a class="float-right">{{ log.created_at | moment("DD.MM.YY., HH:mm") }}</a>
              </footer>
            </b-alert>
          </b-col>
        </b-row>

      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="12">
        <b-row>
          <b-col cols="12" sm="12" class="event shadow-lg p-2 mt-2">
            <b-alert style="margin-bottom: 0px;" :class="isMobile() ? 'elements element': 'element'" variant="success"
                     v-b-toggle.accordion-2 show>
              <b> Kod karte:xxxxxxx xxxxx x - na prolazu x<i class="fa fa-chevron-down float-right"></i></b>
              <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>Detalji očitanja</b-card-text>

                </b-card-body>
              </b-collapse>
              <footer class="blockquote-footer">
                <a class="float-right">Datum očitanja</a>
              </footer>
            </b-alert>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" sm="12" class="event shadow-lg p-2 mt-2">
            <b-alert style="margin-bottom: 0px;" :class="isMobile() ? 'elements element': 'element'" variant="danger"
                     v-b-toggle.accordion-1 show>
              <b> Kod karte:xxxxxxx xxxxx x - na prolazu x<i class="fa fa-chevron-down float-right"></i></b>
              <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>Detalji očitanja</b-card-text>

                </b-card-body>
              </b-collapse>
              <footer class="blockquote-footer">
                <a class="float-right">Datum očitanja</a>
              </footer>
            </b-alert>
          </b-col>

        </b-row>

        <b-row class="shadow-lg">
          <b-col cols="12" sm="12" class="event p-2 mt-2">
            <b-alert style="margin-bottom: 0px;" :class="isMobile() ? 'elements element': 'element'" variant="warning"
                     v-b-toggle.accordion-3 show>
              <b> Kod karte:xxxxxxx xxxxx x - na prolazu x<i class="fa fa-chevron-down float-right"></i></b>
              <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>Detalji očitanja</b-card-text>

                </b-card-body>
              </b-collapse>
              <footer class="blockquote-footer">
                <a class="float-right">Datum očitanja</a>
              </footer>
            </b-alert>
          </b-col>
        </b-row>

      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'eventLogs',
  data() {
    return {
      selected: ['1', '2', '3', '4', '5', '6', '8', '9', '10', '11', '12', '13', '14', '15'],
      selectedStatus: ['info', 'warning', 'success', 'error'],
      logs: [],
      log: false,
      newLog: [],
      tempLogs: [],
      maxLogId: 0,
      prevId: 0,
      isScroll: false,
      options1: [
        {value: '1'},
        {value: '2'},
        {value: '3'},
      ],
      options2: [
        {value: '4'},
        {value: '5'},
        {value: '6'},
      ],
      options3: [
        {value: '7'},
        {value: '8'},
        {value: '9'},
      ],
      options4: [
        {value: '10'},
        {value: '11'},
        {value: '12'},
      ],
      options5: [
        {value: '13'},
        {value: '14'},
        {value: '15'},
      ],
      statusOptions: [
        {text: 'logs.type.types.info', value: 'info'},
        {text: 'logs.type.types.warning', value: 'warning'},
        {text: 'logs.type.types.success', value: 'success'},
        {text: 'logs.type.types.error', value: 'error'}
      ]
    }
  },
  computed: {
    class() {
      return isScroll ? 'scroll' : '';
    }
  },
  methods: {
    getLogs() {
      this.$axios.get('/eventLogs', {
            params: {
              gates: this.selected,
              status: this.selectedStatus
            }
          }
      ).then(response => {
        if (response.status === 200) {
          if (response.data.data) {
            this.logs = response.data.data;
            if (this.logs.length > 0) {
              this.log = !this.log;
              this.maxLogId = this.logs[0].id;
              this.prevId = this.maxLogId;
              if (this.logs.length > 30) {
                this.isScroll = true;
              }
            }
          }
        }
      });
    },
    getNext() {
      this.$axios.get('/nextLogs', {
            params: {
              gates: this.selected,
              status: this.selectedStatus,
              id: this.maxLogId
            }
          }
      ).then(response => {
        if (response.status === 200) {
          if (response.data.data.length > 0) {
            this.newLog = response.data.data;
            this.tempLogs = this.logs
            this.tempLogs = this.tempLogs.concat(this.newLog)
            this.tempLogs.sort(function (a, b) {
              return b.id - a.id
            })
            this.logs = this.tempLogs;
            this.prevId = this.maxLogId;
            this.maxLogId = response.data.data[0].id;
          }
        }
      });
    },
    isMobile() {
      let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (width < 1200) {
        return true;
      } else return false;
    }
  },

  created() {
    let self = this;
    this.getLogs();
    this.isMobile();
    this.interval = setInterval(function () {
      self.getNext();
    }, 1500)
  },
  destroyed() {
    clearInterval(this.interval);
  }
};
</script>
<style>
.event {
  padding: 0 !important;
}

.elements {
}

#bx {
  position: relative;
  -webkit-animation: mymove 1s 1; /* Safari 4.0 - 8.0 */
  animation: mymove 1.5s 1;
}

@keyframes mymove {
  from {
    right: -230px;
    filter: brightness(70%);
  }
  to {
    right: 0px;
    filter: brightness(100%);
  }
}

@-webkit-keyframes mymove {
  from {
    right: -230px;
    filter: brightness(80%);
  }
  to {
    right: 0px;
    filter: brightness(100%);
  }
}

</style>